/* global jQuery Swiper initMap tgInit */

;(function($) {
	$(document).ready(function() {
		// runs for first page load
		init()
	})

	function init() {
		/**
		 * Run initialition for core functionality
		 */
		coreInit()

		/**
		 * run initialisation for external scripts
		 */
		animationInit()
		initMap()
		gridSlider()
	}

	function coreInit() {
		// helps us detect touchscreen-based browsers
		window.isTouch = false
		$(window).one('touchstart', function onFirstTouch() {
			window.isTouch = true
			$('body').addClass('is-touch')
		})

		setScrollbar()

		/**
		 * General/global
		 */
		$('[input-select-all]').on('focus click', function() {
			setTimeout(() => {
				this.focus()
				this.setSelectionRange(0, 99999)
				this.select()
			}, 50)
		})

		/**
		 * navigation
		 */
		// mobile nav toggle
		$('#nav-toggle').click(function() {
			$('#site-navigation').toggleClass('toggled')
			$('#nav-toggle').toggleClass('toggled')
			$('body').toggleClass('is-no-scroll')
			$('#primary-menu .menu-item-has-children>a').removeClass('active').next().slideUp(200)
			$(this).attr(
				'aria-expanded',
				$(this).attr('aria-expanded') === 'false'
			)
		})
		// if mobile nav or if touchscreen, menu items with children can not be followed
		$('#primary-menu .menu-item-has-children>a').click(function(e) {
			if ($(window).width() < 996 || window.isTouch) {
				e.preventDefault()
				e.stopPropagation()
			}
		})
		// mobile menu sub-menu handling
		$('#primary-menu .menu-item-has-children>a').click(function(e) {
			if ($('#site-navigation').hasClass('toggled')) {
				//console.log($(this).html());
				e.preventDefault()
				let dir = $(this).parent().attr('aria-expanded') === 'true'
				if (dir) {
					$(this).next().slideUp(200)
					$(this).parent().attr('aria-expanded', 'false')
				} else {
					$(this).next().slideDown(200)
					$(this).parent().attr('aria-expanded', 'true')
				}

			}
		})
		// when mobile menu open a click to anything else closes it
		$(document).click(function(event) {
			if (!$(event.target).closest('#site-navigation .site-mask, #nav-toggle').length && $('#site-navigation').hasClass('toggled')) {
				$('#site-navigation').removeClass('toggled')
				$('#nav-toggle').removeClass('toggled')
				$('body').removeClass('is-no-scroll')
			}
		})
		// mobile home nav background
		if ($('body').hasClass('home')) {
			navBg()
			$(document).on('scroll.headerbg', throttle(function() {
				navBg()
			}, 50))
			$(document).on('resize.headerbg', throttle(function() {
				navBg()
			}, 50))
		}
		function navBg() {
			if ($(window).width() < 996) {
				let opacity = $(window).scrollTop() / 400
				$('#header .header-bg').css('opacity', opacity > 0.85 ? 0.85 : opacity)
			} else {
				$('#header .header-bg').css('opacity', '')
			}
		}

		/**
		 * page head — carousel
		 */
		// no follow effect
		// if ($('.v-pageHead__slide', '.v-pageHead__slider').length > 1) {
		// 	const $swiper = $('.v-pageHead__slider');
		// 	const $next = $('.floating-nav.next');
		// 	const $prev = $('.floating-nav.prev');

		// 	// Initialise Swiper
		// 	new Swiper('.v-pageHead__slider', {
		// 		autoplay: {
		// 			delay: 7000
		// 		},
		// 		loop: true,
		// 		allowTouchMove: true,
		// 		navigation: false,
		// 		slidesPerView: 2,
		// 		spaceBetween: 15,
		// 	});

		// 	let currentDirection = null;

		// 	if (window.innerWidth >= 768) {
		// 		$swiper.on('mousemove', function (e) {
		// 			const offset = $swiper.offset();
		// 			const width = $swiper.width();
		// 			const x = e.pageX - offset.left;
		// 			const y = e.pageY - offset.top;

		// 			if (x < width / 2) {
		// 				currentDirection = 'prev';
		// 				$prev.css({
		// 					transform: `translate(${x - 100}px, ${y}px)`,
		// 					opacity: 1
		// 				});
		// 				$next.css({ opacity: 0 });
		// 			} else {
		// 				currentDirection = 'next';
		// 				$next.css({
		// 					transform: `translate(${x + 20}px, ${y}px)`,
		// 					opacity: 1
		// 				});
		// 				$prev.css({ opacity: 0 });
		// 			}
		// 		});

		// 		$swiper.on('mouseleave', function () {
		// 			currentDirection = null;
		// 			$next.css({ opacity: 0 });
		// 			$prev.css({ opacity: 0 });
		// 		});

		// 		$swiper.on('click', function () {
		// 			const swiperInstance = this.swiper; // 💡 get the actual Swiper instance

		// 			if (currentDirection === 'next') {
		// 				swiperInstance.slideNext();
		// 			} else if (currentDirection === 'prev') {
		// 				swiperInstance.slidePrev();
		// 			}
		// 		});


		// 	}
		// }

		//follow effect

		const $headlineTopSpans = $('#headline-top span');
		let currentIndex = 0;
		let stopAnimation = 0;
		$headlineTopSpans.hide(); // Hide all spans initially

		function showNextSpan() {
			if (currentIndex < $headlineTopSpans.length && stopAnimation == 0) {
				const $current = $headlineTopSpans.eq(currentIndex);
				$current.slideDown(100).delay(500).slideUp(100, function () {
					currentIndex++;
					showNextSpan(); // Recursively show the next one
				});
			} else {
				stopAnimation = 1;
				onHeadlineTopComplete()
			}
		}

		showNextSpan();

		function onHeadlineTopComplete() {
			console.log("All headline-top spans finished animating.");
			$('#headline-middle').slideUp(100);
			$('#headline-last').slideDown(100);
		}


		if ($('.v-pageHead__slide', '.v-pageHead__slider').length > 1) {
			const $swiper = $('.v-pageHead__slider');
			const $next = $('.floating-nav.next');
			const $prev = $('.floating-nav.prev');

			const swiperiInstance = new Swiper('.v-pageHead__slider', {
				// autoplay: {
				// 	delay: 7000
				// },
				loop: true,
				allowTouchMove: true,
				slidesPerView: 1,
				spaceBetween: 0,
				navigation: true,
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				 pagination: {
					el: ".swiper-pagination",
					type: "fraction",
					renderFraction: function (currentClass, totalClass) {
						return '<span class="' + currentClass + '"></span>' +
								' / ' +
								'<span class="' + totalClass + '"></span>';
					},
					formatFractionCurrent: function (number) {
						number--;
						return number < 10 ? '0' + number : number;
					},
					formatFractionTotal: function (number) {
						number--;
						return number < 10 ? '0' + number : number;
					}
				},
			});



			let currentDirection = null;
			let mouseX = 0;
			let mouseY = 0;
			let floatX = 0;
			let floatY = 0;
			let isHovering = false;
			let hoveringButton = false;
			const offsetX = 10;
			const offsetY = 10;

			function animate() {
				floatX += (mouseX - floatX) * 0.25;
				floatY += (mouseY - floatY) * 0.25;

				if (isHovering && !hoveringButton) {
					if (currentDirection === 'next') {
						$next.css({
							left: (floatX - offsetX) + 'px',
							top: (floatY - offsetY) + 'px',
							opacity: 1
						});
						$prev.css({ opacity: 0 });
					} else if (currentDirection === 'prev') {
						$prev.css({
							left: (floatX - offsetX) + 'px',
							top: (floatY - offsetY) + 'px',
							opacity: 1
						});
						$next.css({ opacity: 0 });
					}
				} else {
					// Hide both when not active or hovering a button
					$next.css({ opacity: 0 });
					$prev.css({ opacity: 0 });
				}

				requestAnimationFrame(animate);
			}

			if (window.innerWidth >= 992) {
				$swiper.on('mousemove', function (e) {
					//const offset = $swiper.offset();
					const rect = this.getBoundingClientRect();
					const width = $swiper.width();

					mouseX = e.clientX;
					mouseY = e.clientY;

					const relativeX = e.clientX - rect.left;

					currentDirection = relativeX < width / 2 ? 'prev' : 'next';
					isHovering = true;
				});

				$swiper.on('mouseleave', function () {
					isHovering = false;
					currentDirection = null;
					$next.css({ opacity: 0 });
					$prev.css({ opacity: 0 });
				});

				$swiper.on('click', function (e) {
					const rect = this.getBoundingClientRect();
					const width = $swiper.width();
					const relativeX = e.clientX - rect.left;
					//stopAnimation = 1;
					//onHeadlineTopComplete();
					const swiperInstance = this.swiper;
					if (relativeX < width / 2) {
						swiperInstance.slidePrev();
					} else {
						swiperInstance.slideNext();
					}
				});


				requestAnimationFrame(animate);
			}

			swiperiInstance.on('slideChangeTransitionEnd', function () {
				$headlineTopSpans.length = 0;

				if(this.realIndex != 0) {
					$('#site-branding .site-title').css('opacity', '1');
					$('.swiper-pagination').css('opacity', '1');
					//$('#headline').css('opacity', '0');
				} else {
					$('#site-branding .site-title').css('opacity', '0');
					$('.swiper-pagination').css('opacity', '0');
					//$('#headline').css('opacity', '1');
				}

				const tcolor = $('.swiper-slide-active').data('text-color');
				if (tcolor) {
					$(':root').get(0).style.setProperty('--headline-color', tcolor);
				}

			});



			// Add hover handlers for buttons
			$(document).on('mouseenter', '.v-pageHead__slideInner', function () {
				hoveringButton = true;
				$('.floating-nav').css('opacity', 0);
			});

			$(document).on('mouseleave', '.v-pageHead__slideInner', function () {
				hoveringButton = false;
			});
		}


		/**
		 * testimonials
		 */
		new Swiper('.v-testimonials .swiper-container', {
			loop: true,
			slidesPerView: 1,
			spaceBetween: 10,
			watchSlidesProgress: true,
			watchSlidesVisibility: true,
			autoplay: {
				delay: 5000,
			},
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true
			},
		})

		/**
		 * gallery section
		 */
		let galleryInit = false
		gallerySlider()
		function gallerySlider() {
			if (window.innerWidth < 992 && !galleryInit) {
				new Swiper('.v-gallery .swiper-container', {
					slidesPerView: 1,
					breakpoints: {
						768: {
							slidesPerView: 2
						}
					}
				})
				galleryInit = true
			} else if (window.innerWidth >= 992 && galleryInit) {
				$('.v-gallery .swiper-container').each(function() {
					$(this)[0].swiper.destroy()
				})
				galleryInit = false
			}
		}
		$(window).on('resize.gallerySlider', throttle(function() {
			gallerySlider()
		}, 50))

		/**
		 * logo slider
		 */
		new Swiper('.v-logos--slider--normal .v-logos__slider', {
			loop: true,
			slidesPerView: 1,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			},
			watchSlidesProgress: true,
			watchSlidesVisibility: true,
			breakpoints: {
				540: {
					slidesPerView: 2
				},
				768: {
					slidesPerView: 3
				},
				996: {
					slidesPerView: 5
				}
			}
		})
		new Swiper('.v-logos--slider--large .v-logos__slider', {
			slidesPerView: 1,
			watchSlidesProgress: true,
			watchSlidesVisibility: true,
			loop: true,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			},
			breakpoints: {
				768: {
					slidesPerView: 2
				},
				992: {
					slidesPerView: 3
				}
			}
		})

		/**
		 * news slider
		 */
		new Swiper('.v-news__slider', {
			autoplay: {
				delay: 4000
			},
			loop: true,
			slidesPerView: 1,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			},
			breakpoints: {
				768: {
					slidesPerView: 2
				},
				1199: {
					slidesPerView: 3
				},
				1399: {
					slidesPerView: 4
				}
			}
		})

		/**
		 * advanced content image slider
		 */
		new Swiper('.v-content__advanced-item--image_slider', {
			slidesPerView: 1,
			watchSlidesProgress: true,
			watchSlidesVisibility: true,
			breakpoints: {
				768: {
					slidesPerView: 2
				},
				996: {
					slidesPerView: 3
				}
			}
		})

		/**
		 * switch modal
		 */
		$('.switch-modal').click(function() {
			var modal_close = $(this).closest('.modal');
			var modal_open = $(this).data('target');
			$(modal_close).modal('hide');
			$(modal_close).one('hidden.bs.modal', function () {
				$(modal_open).modal('show');
			});
		});
		/**
		 * skip link
		 */
		$('.skip-link').click(function(event) {
			event.preventDefault();
			var skipto = $(this).data('skipto');
			if (skipto) {
				var skipPage = $('html, body');

				skipPage.on('mousedown wheel DOMMouseScroll mousewheel touchmove', function() {
					skipPage.stop();
				});

				skipPage.animate({
					scrollTop: $(skipto).offset().top - $('#header').height()
				}, 1000, function () {
					skipPage.off('mousedown wheel DOMMouseScroll mousewheel touchmove')
				})
			}
		});

		/**
		 * location section
		 */
		// location section hover
		$('.v-locations__mapMarker').hover(function() {
			$('.v-locations__list').addClass('map-hover')
			$('.v-locations__list li').eq($(this).index() - 1).addClass('is-hover')
		}, function() {
			$('.v-locations__list').removeClass('map-hover')
			$('.v-locations__list li').removeClass('is-hover')
		})
		$('.v-locations__list-button').hover(function() {
			$('.v-locations__map').addClass('list-hover')
			$('.v-locations__mapMarker').eq($(this).parent().index()).addClass('is-hover')
		}, function() {
			$('.v-locations__map').removeClass('list-hover')
			$('.v-locations__mapMarker').removeClass('is-hover')
		})
		// toggle address panel
		$('.v-locations__list-button, .v-locations__mapMarker').click(function() {
			const i = $(this).hasClass('v-locations__list-button') ? $(this).parent().index() : $(this).index() - 1
			const $addressPanel = $('.v-locations__address')
			const $addresses = $('.v-locations__addressItem')
			const $locationList = $('.v-locations__list')
			const $locations = $('.v-locations__list li')
			const wasVisible = $addresses.eq(i).hasClass('is-visible')

			$locationList.removeClass('address-active')
			$addressPanel.removeClass('is-active')
			$locations.removeClass('is-active').removeClass('is-hover')
			$addresses.removeClass('is-visible')
			if (!wasVisible) {
				$locationList.addClass('address-active')
				$addressPanel.addClass('is-active')
				$locations.eq(i).addClass('is-active')
				$addresses.eq(i).addClass('is-visible')
			}
		})
		// close address panel
		$('.v-locations__addressClose').click(function() {
			$('.v-locations__list').removeClass('address-active')
			$('.v-locations__list li').removeClass('is-active')
			$('.v-locations__address').removeClass('is-active')
			$('.v-locations__addressItem').removeClass('is-visible')
		})

		/**
		 * advanced focus handling
		 */
		$('.v-panels__button').click(function() {
			$(this).next().focus()
		})

		/**
		 * social sharing
		 */
		$('.v-share__btn--general').click(function() {
			if (navigator.share) {
				navigator.share({
					url: $(this).data('url'),
					title: $(this).data('title'),
					text: $(this).data('text')
				})
			} else {
				$.fancybox.open({
					src: '#social-share-modal'
				})
			}
		})

		$('.v-share-modal__copy-button').click(function() {
			let link = $(this).prev()[0]
			let currentFocus = document.activeElement
			link.focus()
			link.setSelectionRange(0, link.value.length)
			let success
			try {
				success = document.execCommand('copy')
			} catch (e) {
				success = false
			}
			if (currentFocus && typeof currentFocus.focus === 'function') {
				currentFocus.focus()
			}

			if (success) {
				let parent = $(this).parent()
				parent.removeClass('is-copied')
				void parent[0].offsetWidth
				parent.addClass('is-copied')
			}
		})

		Fancybox.bind("[data-fancybox]", {
			// Your custom options
		});


		 var swiper = new Swiper(".workSwiper", {
			slidesPerView: 1,
			spaceBetween: 30,
			loop: true,
			//autoHeight: true,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			});

		/**
		 * gravity extra fields animation
		 */
		$('.expand-extra input').on('change', function() {
			if ($(this).prop("checked")) {
				$(this).closest('.gform_body').addClass('show-expand');
			} else {
				console.log('there');
				$(this).closest('.gform_body').removeClass('show-expand');
			}
		});

		/**
		 * footer
		 */
		// mobile footer 'accordion' on mobile
		$('.footer-accordion-button').click(function() {
			if ($(window).width() < 996) {
				$(this)
					.closest('.accordion')
					.toggleClass('shown')
			}
		})

	}

	function gridSlider() {
		if ($('.v-gridSlider').length) {
			let rows = 2
			if ($(window).width() < 768) {
				rows = 1
			}
			$('.v-gridSlider .tg-layout-grid').data('row', rows)
			tgInit()

			const rightArrow = $('.v-gridSlider__arrow.tg-right-arrow')
			rightArrow.before(rightArrow.next())

			const MutationObserver = window.MutationObserver || window.WebKitMutationObserver
			const observer = new MutationObserver(throttle(gridSliderMutation, 300))
			const obsConfig = {
				attributeFilter: ['style'],
				attributes: true,
				characterData: false,
				subtree: false
			}

			$('.v-gridSlider .tg-layout-grid').each(function() {
				observer.observe(this, obsConfig)
			})
		}
	}

	function gridSliderMutation(mutationRecords) {
		$.each(mutationRecords, function(i, mutation) {
			const $gridSlider = $(mutation.target)
			const width = $gridSlider.parent().outerWidth()

			const transform = $gridSlider.css('transform')
			let matrixIndex
			if (transform.substring(0, 8) === 'matrix3d') {
				matrixIndex = 13
			} else {
				matrixIndex = 4
			}
			const transformX = parseFloat(transform.match(/-?[\d.]+/g)[matrixIndex])

			$gridSlider.children().each(function() {
				const left = parseFloat($(this).css('left'))
				const center = left + ($(this).outerWidth() / 2)
				const offset = center + transformX

				if (offset > -10 && offset < width + 10) {
					$(this).addClass('tg-item-active')
				} else {
					$(this).removeClass('tg-item-active')
				}
			})
		})
	}

	function animateOut() {
		// hide nav
		$('#site-navigation').removeClass('toggled')
		$('#nav-toggle').removeClass('toggled')
	}



	// set scrollbar
	function setScrollbar() {
		var body = document.querySelector('body')
		if (window.innerWidth > body.clientWidth + 5) {
			$('body').removeClass('no-scrollbar')
			document.documentElement.style.setProperty(
				'--scrollbar-width',
				window.innerWidth - body.clientWidth + 'px'
			)
		} else {
			$('body').addClass('no-scrollbar')
		}
	}

	// Returns a function, that, when invoked, will only be triggered at most once
	// during a given window of time. Normally, the throttled function will run
	// as much as it can, without ever going more than once per `wait` duration;
	// but if you'd like to disable the execution on the leading edge, pass
	// `{leading: false}`. To disable execution on the trailing edge, ditto.
	function throttle(func, wait, options) {
		var context, args, result
		var timeout = null
		var previous = 0
		if (!options) options = {}
		var later = function() {
			previous = options.leading === false ? 0 : Date.now()
			timeout = null
			result = func.apply(context, args)
			if (!timeout) context = args = null
		}
		return function() {
			var now = Date.now()
			if (!previous && options.leading === false) previous = now
			var remaining = wait - (now - previous)
			context = this
			args = arguments
			if (remaining <= 0 || remaining > wait) {
				if (timeout) {
					clearTimeout(timeout)
					timeout = null
				}
				previous = now
				result = func.apply(context, args)
				if (!timeout) context = args = null
			} else if (!timeout && options.trailing !== false) {
				timeout = setTimeout(later, remaining)
			}
			return result
		}
	}

	$('.toggle-audio').on('click', function() {
		var video = $(this).data('video');

		if ($(this).hasClass('audio-on')) {
			$(this).removeClass('audio-on');
			$(video).prop('muted', true);
		} else {
			$(this).addClass('audio-on');
			$(video).prop('muted', null);
		}
	});

	if ('IntersectionObserver' in window) {
		const observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					entry.target.classList.add('content-animation');
					return;
				}
			});
		});

		// Get multiple elements instead of a single one using "querySelectorAll"
		const content_animate = document.querySelectorAll('.content-animate');

		// Loop over the elements and add each one to the observer
		content_animate.forEach((element) => observer.observe(element));

	} else {
		//no animation will work. so default view.
		$('.content-animate').addClass('content-animation');
	}

	// Save scroll position
	//const scrollTop = $(window).scrollTop();
	// $('body.home').addClass('scroll-lock').css({ top: `-${scrollTop}px` });
	// window.onbeforeunload = function () {
	// 	window.scrollTo(0, 0);
	// };

	$(document).ready(function () {
		if(!$('body').hasClass('home')) {
			$('#site-branding .site-title').css('opacity', '1');
		}
		// $(this).scrollTop(0);
		// const $scrollHead = $('#scroll_head');
		// const $scrollHeadBack = $('#scroll_head_back');

		// const $headline = $('#headline');
		// const $headlineTop = $('#headline-top');
		// //const $headlineLast = $('#headline-last');
		// //const $headlineFirst = $('#headline-first');
		// const $intro = $('#intro');
		// const $headCarousel = $('#page-head');

		// // setTimeout(function () {
		// // 	$headlineLast.css('opacity', '1');
		// // 	$headlineFirst.css('opacity', '0');
		// // }, 6000);

		// const fullHeight = window.innerHeight;
		// const minHeight = 0;
		// const shrinkDistance = fullHeight - minHeight;

		// const originalFontSize = parseFloat($headline.css('font-size'));
		// const minFontSize = 30;
		// const minScale = minFontSize / originalFontSize;

		//$(window).on('scroll', function () {
			// const scrollY = $(window).scrollTop();
			// const progress = Math.min(scrollY / shrinkDistance, 1);

			// const variableHeight = fullHeight - (progress * shrinkDistance);
			// const startScale = 1;
			// const endScale = 0.149626;
			// let scale = startScale - (progress * (startScale - endScale));
			// scale = Math.max(scale, minScale);

			// const maxMarginTop = 120;
			// const marginTop = progress * maxMarginTop;

			// if (progress < 1) {
			// 	$scrollHead.removeClass('sticky').css('height', `${variableHeight}px`);

			// 	//$scrollHeadBack.css('height', `${newHeight}px`);
			// 	$headline.css({
			// 		'transform': `scale(${scale})`,
			// 		'margin-top': `${marginTop}px`
			// 	});

			// 	$headlineTop.css({
			// 		'transform': `scale(${scale})`
			// 	});
			// } else {
			// 	$scrollHead.addClass('sticky').css('height', `${minHeight}px`);
			// 	//$scrollHeadBack.css('height', `${minHeight}px`);
			// 	// $headline.css({
			// 	// 	'transform': 'scale(0.102)',
			// 	// 	'margin-top': '120px'
			// 	// });
			// }

			//Carousel div
			// const headCarousel = $headCarousel[0].getBoundingClientRect().top;
			// //console.log('head: ' + headCarousel);
			// if (headCarousel < 120) {
			// 	$headCarousel.addClass('reached-top');
			// 	$('#header').addClass('footer-top-adjust');
			// 	const colorVar = $('.swiper-slide-active').data('text-color');
			// 	//console.log(colorVar);
			// 	$(':root').get(0).style.setProperty('--headline-color', `${colorVar}`);
			// } else {
			// 	$(':root').get(0).style.setProperty('--headline-color', 'var(--secondary-color)');
			// 	$headCarousel.removeClass('reached-top');
			// 	$('#header').removeClass('footer-top-adjust');
			// }

			//Intro div as Footer
			// const intro = $intro[0].getBoundingClientRect().top;

			// if (intro < 60) {
			// 	//console.log('intro: colour changed');
			// 	$('#intro').addClass('reached-top');

			// 	$(':root').get(0).style.setProperty('--headline-color', 'white');
			// } else {
			// 	$('#intro').removeClass('reached-top');

			// }

		//});
	});




})(jQuery);
